import { useUserSession } from '@solinkcorp/authentication';
import CloudAiApi, { type UsageQuota } from 'clients/CloudAiApi';
import useSWR from 'swr';

function useCustomerSpotCheckUsage(shouldFetch = false): {
  isLoading: boolean;
  usageStats: UsageQuota | undefined;
} {
  const userSession = useUserSession();
  const customerId = userSession.profile?.customerId;

  const { data: usageStats, isLoading } = useSWR(
    shouldFetch && customerId ? 'spot-check-usage-stats' : null,
    () => CloudAiApi.getCustomerSpotCheckUsage(userSession.accessToken, customerId ?? ''),
    {
      revalidateOnFocus: false,
      errorRetryCount: 3,
    },
  );

  return { isLoading, usageStats };
}

export default useCustomerSpotCheckUsage;
